(function() {
  const initializeTabNavigation = () => {
    const tabsNav = document.querySelector('.tabs-nav');

    if(tabsNav) {
          tabsNav.addEventListener('click', e => {
            if (!e.target.classList.contains('tab-btn')) return;
      
            document.querySelectorAll('.tab-btn').forEach(btn => {
              btn.classList.remove('active');
              btn.setAttribute('aria-selected', 'false');
            });
            
            e.target.classList.add('active');
            e.target.setAttribute('aria-selected', 'true');
            
            document.querySelectorAll('.tab-panel').forEach(panel => {
              panel.classList.remove('active');
              panel.setAttribute('hidden', '');
            });
            
            const tabId = `tab-${e.target.dataset.tab}`;
            const activePanel = document.getElementById(tabId);
            activePanel.classList.add('active');
            activePanel.removeAttribute('hidden');
          }); 
    }
  }  

  const handleVariantChange = () => {
    const variantSelector = document.querySelector('variant-radios, variant-selects');
    if (variantSelector) {
      variantSelector.addEventListener('change', function() {
        const url = this.dataset?.url;
        const variantenId = this.currentVariant?.id;

        const tabsSection = document.querySelector(`[data-section-product-tabs-id]`);
      
        if(!tabsSection || !url || !variantenId) return;
      
        const tabsSectionId = tabsSection.dataset.sectionProductTabsId;
      
        if(!tabsSectionId) return;
      
        
        console.log({
          url: url,
          variantenId: variantenId,
          tabsSectionId: tabsSectionId,
          variantfetchUrl: `${url}?variant=${variantenId}&section_id=${tabsSectionId}`
        });
        const variantfetchUrl =  `${url}?variant=${variantenId}&section_id=${tabsSectionId}`
        fetch(variantfetchUrl)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            tabsSection.innerHTML = html.querySelector(`[data-section-product-tabs-id]`).innerHTML;
            initializeTabNavigation();
          });
      });
    }
  }

  // Initialisierung
  initializeTabNavigation();
  handleVariantChange();
}());